import { render } from "./contentsDetailView.vue?vue&type=template&id=3fa3673f&scoped=true"
import script from "./contentsDetailView.vue?vue&type=script&lang=js"
export * from "./contentsDetailView.vue?vue&type=script&lang=js"

import "./contentsDetailView.vue?vue&type=style&index=0&id=3fa3673f&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa3673f"]])

export default __exports__